import { useSpaUrl } from "@serophin/browser";
import type { ComponentChildren } from "preact";
import { useEffect } from "preact/hooks";
import { Layout, SiteRoot } from "./layout/Layout";
import { pathnameOf } from "./layout/navClasses";
import { useIsSignedIn } from "./platform/session";
import { isBarePath } from "./routes";
import { clearSeeds } from "./seeds";

let firstFrame = true;

/**
 * Every route renders inside this, and it is mounted again for every navigation to another route (a change
 * of query string only keeps it). That makes it the place for what happens when the visitor moves on: the
 * prerendered seeds go stale and the page starts at the top, unless the url names an anchor.
 */
export const Frame = ({ children }: { children: ComponentChildren }) => {
  const path = pathnameOf(useSpaUrl());
  const signedIn = useIsSignedIn();

  useEffect(() => {
    if (firstFrame) {
      firstFrame = false;
      return;
    }
    clearSeeds();
    if (!window.location.hash) {
      window.scrollTo(0, 0);
    }
  }, []);

  return isBarePath(path, signedIn) ? <SiteRoot path={path}>{children}</SiteRoot> : <Layout path={path}>{children}</Layout>;
};
